import { twMerge } from "tailwind-merge";

export const DATA_BREADCRUMBS_PORTAL_ID = "breadcrumbs-portal";

export function BreadcrumbsPortal() {
  return (
    <div
      data-breadcrumbs-portal={DATA_BREADCRUMBS_PORTAL_ID}
      className={twMerge(
        "h-[--breadcrumbs-height]",
        "[&_.ant-breadcrumb_>_ol]:w-full",
        "[&_.ant-breadcrumb_>_ol]:flex-nowrap",
        "[&_.ant-breadcrumb_>_ol_p]:whitespace-nowrap",
        "[&_.ant-breadcrumb_>_ol]:overflow-x-auto",
        "[&_.ant-breadcrumb_>_ol]:overflow-y-hidden",

        // крошка сжимается и обрезается только если строка не влезает в контейнер:
        // min-w-0 разрешает flex-элементу стать уже своего контента,
        // разделители и иконка "домой" при этом не сжимаются
        "[&_.ant-breadcrumb_>_ol_>_li]:min-w-0",
        "[&_.ant-breadcrumb_>_ol_>_li:first-child]:shrink-0",
        "[&_.ant-breadcrumb_>_ol_>_li.ant-breadcrumb-separator]:shrink-0",
      )}
    />
  );
}
